module.exports = __webpack_public_path__ + "img/nodered.871123ac.png";